import { TablePagination } from "@mui/material";
import { useTablaCarpetaContext } from "../../logics/TablaCarritoProvider";

const TableCarpetaPagination = () => {
    const { context } = useTablaCarpetaContext();
    const { page, perPage, total, nextPage, prevPage, changePerPage } = context;

    const handleChangePage = (event: unknown, newPage: number) => {
        newPage + 1 > page ? nextPage() : prevPage();
    }

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newPerPage = parseInt(event.target.value, 10);
        changePerPage(newPerPage);
    }

    return (<TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={total}
        rowsPerPage={perPage}
        page={page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
    />
    );
}

export default TableCarpetaPagination;